import { REPORTS_ENDPOINT } from "../../constants";
import { reportSummaryQuery } from "../utils";
import { baseApi } from "./base.api.required.stub";
const sharedApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getReportSummary: build.query({
            query: reportSummaryQuery,
        }),
        getReportMappings: build.query({
            query: () => ({
                url: `/reports/v1/report-mappings`,
            }),
        }),
        getSoftwareDependencyDetails: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/dependencies/${data.ui_item_id}/components`,
                params: data,
            }),
        }),
    }),
    overrideExisting: true,
});
export const { useGetReportSummaryQuery, useGetReportMappingsQuery, useGetSoftwareDependencyDetailsQuery, } = sharedApi;
//# sourceMappingURL=shared.api.js.map